import React from "react";
import PageTitle from "../components/PageTitle";

const RightCashComplaints = () => {
  PageTitle(
    "Pawnbroking Complaints Handling Procedure - Right Cash - We Buy, We Sell, Buybacks, Pawnbrokers. Get Cash Fast - Chatham, Kent - Pawn Shop"
  );
  return (
    <div className="complaints-container">
      <h1>Right Cash Ltd</h1>
      <h2>Complaints / Dispute Handling Procedure (Pawnbroking Only)</h2>

      <p>
        For any complaints regarding other services, please call{" "}
        <strong>01634 830987</strong> for an immediate response or email{" "}
        <a href="mailto:Chatham@rightcash.co.uk">Chatham@rightcash.co.uk</a>.
      </p>

      <h3>What We Consider a Complaint</h3>
      <p>
        Any oral or written expression of dissatisfaction, whether justified or
        not, from, or on behalf of, a person about the provision of, or failure
        to provide, a financial service, which:
      </p>
      <ul>
        <li>
          Alleges that the complainant has suffered (or may suffer) financial
          loss, material distress or material inconvenience;
        </li>
        <li>
          Relates to an activity of our firm which is subject to the
          jurisdiction of the FOS.
        </li>
      </ul>

      <h3>Making a Complaint</h3>
      <p>
        We do not charge for handling complaints. You can contact us in the
        following ways:
      </p>
      <ul>
        <li>
          <strong>Telephone:</strong> 01634 830987 (During normal opening hours)
        </li>
        <li>
          <strong>Email:</strong> Chatham@rightcash.co.uk (Usually answered
          within 1 working day)
        </li>
        <li>
          <strong>Letter:</strong> Complaints Department, Right Cash, 421 High
          St, Chatham, Kent, ME4 4NU
        </li>
        <li>
          <strong>In Store:</strong> Speak to the Manager or Supervisor
        </li>
      </ul>

      <h3>Acknowledging your Complaint</h3>
      <p>
        If your complaint cannot be resolved within 72 hours, we will promptly
        send you a written acknowledgement. If you made your complaint orally,
        we will confirm our understanding in writing.
      </p>

      <h3>Reviewing your Complaint</h3>
      <p>
        Your complaint will be investigated diligently and assessed fairly and
        promptly. We may ask for further documentation or information to assist
        in our investigation.
      </p>

      <h3>Keeping You Informed</h3>
      <p>
        If we can’t resolve your complaint within 72 hours, we will keep you
        updated regularly. If our investigation takes longer than 56 days, we’ll
        let you know when to expect a final response and provide contact details
        for the Financial Ombudsman Service (FOS).
      </p>

      <h3>Financial Ombudsman Service</h3>
      <address>
        Exchange Tower, London, E14 9SR
        <br />
        Telephone: 0845 080 1800
        <br />
        Email: enquiries@financial-ombudsman.org.uk
      </address>

      <h3>Resolving your Complaint</h3>
      <p>
        Once our investigation is complete, we’ll send you a Final Response
        letter that:
      </p>
      <ul>
        <li>Is fair, clear and not misleading</li>
        <li>Explains our investigation and decision</li>
        <li>Includes any redress or remedial actions if applicable</li>
      </ul>

      <p>
        If you’re still not satisfied, you may refer the case to FOS within 6
        months of our Final Response. They may decline to investigate if:
      </p>
      <ul>
        <li>We haven’t had a chance to resolve the complaint</li>
        <li>56 days haven’t passed since the complaint was made</li>
      </ul>

      <p>
        If resolved within 72 hours, we’ll send a Summary Letter with our
        resolution, further steps (if any), and again provide details for the
        FOS if you're unsatisfied.
      </p>

      {/* Inline simple CSS */}
      <style>{`
        .complaints-container {
          max-width: 800px;
          margin: 30px auto;
          padding: 20px;
          background-color: #f9f9f9;
          border: 1px solid #ddd;
          font-family: Arial, sans-serif;
          color: #333;
        }
        h1 {
          text-align: center;
          font-size: 26px;
        }
        h2 {
          text-align: center;
          font-size: 20px;
          margin-bottom: 20px;
        }
        h3 {
          margin-top: 20px;
          font-size: 18px;
        }
        ul {
          padding-left: 20px;
          margin-bottom: 15px;
        }
        ul li {
          margin-bottom: 8px;
        }
        address {
          font-style: normal;
          margin-top: 10px;
          line-height: 1.6;
        }
        a {
          color: #0077cc;
        }
      `}</style>
    </div>
  );
};

export default RightCashComplaints;
